import { Component } from 'react';

class IsNotDomestic extends Component {

    static checkDomesticUser(callback) {
        var self = IsNotDomestic.__SingletonRef;
        if(!self){
            console.log("CHECK DOMESTIC USER!");
            var xhr = new XMLHttpRequest();
            var protocol = window.location.protocol;
            xhr.open("GET", protocol+"//www.bbc.com/future/clientside-helper/is-domestic-user", true);
            xhr.onload = function (e) {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        
                        try {
                            var response = JSON.parse(xhr.responseText)
                            if (typeof response['isDomesticUser'] !== 'undefined' && response.isDomesticUser === false) {
                                IsNotDomestic.isNotDomesticUser = true;
                                for (let index = 0; index < IsNotDomestic.callbacks.length; index++) {
                                    const callback = IsNotDomestic.callbacks[index];
                                    callback();
                                }
                            } else {

                            }
                        } catch (exception) {

                        }
                
                    } else {
                    }
                }
            };
            xhr.onerror = function (e) {
                // console.log(e);
            };
            xhr.send(null);

        }
        IsNotDomestic.callbacks.push(callback)
    }    
    
    static callbacks = [];
    static isNotDomesticUser = false;

    constructor(props){
        super(props);

        this.onCheckComplete = this.onCheckComplete.bind(this)

        if(!IsNotDomestic.__SingletonRef){
            
            IsNotDomestic.checkDomesticUser(this.onCheckComplete);
            IsNotDomestic.__SingletonRef = this

        }else{

            IsNotDomestic.checkDomesticUser(this.onCheckComplete);

        }

        this.state = {
			isNotDomestic: IsNotDomestic.isNotDomesticUser
        };
        
    }

    onCheckComplete(){

        this.setState({
            isNotDomestic: IsNotDomestic.isNotDomesticUser
        })

    }

    render(){
        return (
            (this.state.isNotDomestic ? this.props.children :  null )
        );
    }
}

export default IsNotDomestic;

